export default {
  attendant: 'Atendente',
  status: 'En línea',
  paused: 'En pausa',
  invisible: 'Invisible',
  total: 'Total',
};
